import { Row, Col } from "react-bootstrap";

const OrderSummary = ({ summary }) => {
  const due = summary.grand_total - summary.paid;
  return (
    <>
      <h5 className="font-size-15">
        Order Summary
        <span
          className={`badge bg-${
            due > 0 ? "warning" : "success"
          } font-size-12 ms-2`}
        >
          {due > 0 ? "Unpaid" : "Paid"}
        </span>
      </h5>
      <hr className="my-2" />
      <Row xs={1} sm={3} md={3} xl={4} className="print-reduce-font-size">
        <Col>
          <span className="text-muted">Billed : </span>
          <span className="">{summary.grand_total}</span>
        </Col>
        <Col>
          <span className="text-muted">Taxable : </span>
          <span className="">{summary.gross_item_taxable}</span>
        </Col>
        <Col>
          <span className="text-muted">Item Disocunt : </span>
          <span className="">{summary.gross_item_discount}</span>
        </Col>
        <Col>
          <span className="text-muted">Total GST : </span>
          <span className="">{summary.gross_gst}</span>
        </Col>
        <Col>
          <span className="text-muted">Other Charges : </span>
          <span className="">{summary.other_charges}</span>
        </Col>
        <Col>
          <span className="text-muted">Other Disocunt : </span>
          <span className="">{summary.other_discounts}</span>
        </Col>
        <Col>
          <span className="text-muted">Paid : </span>
          <span className="">{summary.paid}</span>
        </Col>
        <Col>
          <span className="text-muted">{due >= 0 ? "Due" : "Advance"} : </span>
          <span className="">{due < 0 ? due * -1 : due}</span>
        </Col>
        <Col>
          <span className="text-muted">Status : </span>
          <span className="">{summary.is_open ? "Draft" : "Closed"}</span>
        </Col>
      </Row>
    </>
  );
};
export default OrderSummary;
